<template lang="pug">
  q-page.geometry.q-pa-sm
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-4
                q-field(label-width="2", helper="tool diameter")
                  q-input(v-model="d", type="number" suffix="mm")
                  div(slot="label", v-katex="'D'")
                q-field(label-width="2", helper="tool radius")
                  q-input(v-model="r", type="number" suffix="mm")
                  div(slot="label", v-katex="'R'")
                q-field(label-width="2", helper="flute count")
                  q-input(v-model="z", type="number" suffix="")
                  div(slot="label", v-katex="'Z'")
              .col-4
                q-field(label-width="2", helper="cutting speed")
                  q-input(v-model="vc", type="number" suffix="m/min")
                  div(slot="label", v-katex="'v_c'")
                q-field(label-width="2", helper="feed rate")
                  q-input(v-model="vf", type="number" suffix="mm/min")
                  div(slot="label", v-katex="'v_f'")
                q-field(label-width="2", helper="axial doc")
                  q-input(v-model="ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_p'")
                q-field(label-width="2", helper="radial doc")
                  q-input(v-model="ae", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_e'")
              .col-4
                q-field(label-width="2", helper="feed per tooth")
                  q-input(v-model="fz", type="number" suffix="mm/min")
                  div(slot="label", v-katex="'f_z'")
                q-field(label-width="2", helper="revolutions")
                  q-input(v-model="n", type="number" suffix="1/min")
                  div(slot="label", v-katex="'n'")
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-6
                q-field(label-width="2", helper="material removal rate")
                  div
                    span {{Q}}
                    span(v-katex="'\\\\frac{\\\\text{cm}^3}{\\\\text{min}}'")
                  div(slot="label", v-katex="'Q'")
                q-field(label-width="2", helper="average chip thickness")
                  q-input(v-model="hm_ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'h_{m,a_p}'")
                q-field(label-width="2", helper="average chip thickness")
                  q-input(v-model="hm_ae", type="number" suffix="mm")
                  div(slot="label", v-katex="'h_{m,a_e}'")
              .col-6
                q-field(label-width="2", helper="cusp height")
                  .row.gutter-md.flex
                    .col
                      q-input(v-model="Rz", type="number" suffix="μm")
                    .col-auto
                      q-btn(round icon="fa fa-calculator" @click="compute('Rz')")
                  div(slot="label", v-katex="'R_z'")
                q-field(label-width="2", helper="roughness")
                  .row.gutter-md.flex
                    .col
                      q-input(v-model="Ra", type="number" suffix="μm")
                    .col-auto
                      q-btn(round icon="fa fa-calculator" @click="compute('Ra')")
                  div(slot="label", v-katex="'R_a'")
</template>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';
import CuttingDataMixin from '@/mixins/cutting-data.js';

export default {
  name: 'home',
  components: {
  },
  mixins: [CuttingDataMixin],
}
</script>
